export default __webpack_public_path__ + "static/media/battery.4fadba83.svg";